export default function encodeWindowFeatures(featureMap: {[key: string]: any}): string {
  return Object.keys(featureMap).map(key => `${key}=${featureMap[key]}`).join(',');
}